export default function generateClass (style: any, prefix: string, myClass: string) {
  return style?.[`${prefix}${myClass}`]
}

